module.exports = __webpack_public_path__ + "static/media/dot-uncheck.5f2b2f5a.png";